import { render, staticRenderFns } from "./StudentPaymentPlan.vue?vue&type=template&id=63df5f1a&scoped=true"
import script from "./StudentPaymentPlan.vue?vue&type=script&lang=js"
export * from "./StudentPaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./StudentPaymentPlan.vue?vue&type=style&index=0&id=63df5f1a&prod&scoped=true&lang=css"
import style1 from "./StudentPaymentPlan.vue?vue&type=style&index=1&id=63df5f1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df5f1a",
  null
  
)

export default component.exports